import { Tooltip } from '@design-system';
import classNames from 'classnames';
import { useRef } from 'react';

import { Image } from '../../Image';
import { VariantIconSvg } from './VariantIconSvg';

export const VariantIcon = ({
  active = false,
  backgroundColours = ['#F9F6F4'],
  crossedOut = false,
  disabled = false,
  size = 36,
  text,
  textStyle = 'dark',
  thumbnail = undefined,
  tooltipText,
}: {
  active?: boolean;
  backgroundColours?: string[];
  crossedOut?: boolean;
  size?: 36 | 60;
  disabled?: boolean;
  text?: string;
  thumbnail?: string;
  tooltipText: string;
  textStyle?: 'light' | 'dark';
}) => {
  const parentRef = useRef<HTMLDivElement>(null);
  const selectionRef = useRef<HTMLDivElement>(null);

  return (
    <div ref={parentRef} aria-label={tooltipText}>
      <div
        ref={selectionRef}
        className={classNames(
          'group relative',
          disabled
            ? 'cursor-not-allowed opacity-50'
            : 'cursor-pointer opacity-100',
        )}
        style={{ width: size, height: size }}
      >
        {thumbnail ? (
          <div
            className={classNames(
              'inset-0 overflow-hidden rounded-md border-2 transition-all duration-300',
              active ? 'border-neutral-6' : 'border-neutral-2',
              { 'group-hover:border-neutral-4': !disabled },
            )}
          >
            <Image
              alt={tooltipText}
              src={thumbnail}
              width={64}
              className="rounded-[6px] border-2 border-white"
            />
          </div>
        ) : (
          <VariantIconSvg
            active={active}
            backgroundColours={backgroundColours}
            crossedOut={crossedOut}
            size={size}
            disabled={disabled}
            text={text}
            textStyle={textStyle}
          />
        )}
      </div>

      <Tooltip parentRef={parentRef} selectionRef={selectionRef}>
        {tooltipText}
      </Tooltip>
    </div>
  );
};
